import type { Patient } from '@/types/models';

/**
 * Ponte ficha → chat: qualquer tela pede ao FloatingChat (sempre montado no
 * Shell) que abra e já anexe o paciente à próxima mensagem — o mesmo vínculo
 * clicável do botão "Citar paciente" da composição. Evento de janela pra não
 * acoplar a ficha ao estado interno do chat.
 */
export const CHAT_CITE_PATIENT_EVENT = 'dratento:chat-cite-patient';

export function requestChatCitePatient(patient: Patient): void {
  window.dispatchEvent(new CustomEvent<Patient>(CHAT_CITE_PATIENT_EVENT, { detail: patient }));
}
